const moments = [
  { number: '01', title: 'Conversemos', text: 'Cuéntanos qué servicio y diseño tienes en mente.' },
  { number: '02', title: 'Confirmamos', text: 'Poleth revisará disponibilidad, tiempo y valor final contigo.' },
  { number: '03', title: 'Tu momento', text: 'Disfruta una atención tranquila, dedicada y sin prisas.' },
];

export default function Experience() {
  return (
    <section className="section experience" aria-labelledby="experience-title">
      <div className="container">
        <div className="section-heading section-heading--center">
          <p className="eyebrow">La experiencia</p>
          <h2 className="section-title" id="experience-title">Simple, cercana y personalizada.</h2>
        </div>
        <ol className="experience__steps">
          {moments.map((moment) => (
            <li key={moment.number}>
              <span>{moment.number}</span>
              <h3>{moment.title}</h3>
              <p>{moment.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
